import React, { useState, useEffect, useCallback } from 'react';
import './GalleryViewer.css';
import { API_BASE } from '../api';

function resolveSrc(p) {
  if (!p) return (API_BASE || '') + '/placeholder.png';
  if (/^https?:\/\//i.test(p)) return p;
  const path = p.startsWith('/') ? p : '/' + p;
  return (API_BASE || '') + path;
}

export default function GalleryViewer({ images = [], alt = '', showThumbs = true, compact = false }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [images]);

  const prev = useCallback(() => setIndex(i => (i - 1 + images.length) % images.length), [images.length]);
  const next = useCallback(() => setIndex(i => (i + 1) % images.length), [images.length]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [prev, next]);

  if (!images || images.length === 0) return null;

  const mainStyle = compact ? { height: 140 } : { height: 320 };

  return (
    <div className="gallery-viewer" role="region" aria-label="Image gallery">
      <div className="gv-main" style={mainStyle}>
        <button className="gv-nav gv-prev" onClick={prev} aria-label="Previous image">‹</button>
        <img src={resolveSrc(images[index])} alt={alt || `gallery ${index+1}`} />
        <button className="gv-nav gv-next" onClick={next} aria-label="Next image">›</button>
      </div>
      {showThumbs && (
        <div className="gv-thumbs">
          {images.map((img, i) => (
            <button key={i} className={`gv-thumb ${i===index? 'active':''}`} onClick={() => setIndex(i)}>
              <img src={resolveSrc(img)} alt={`thumb ${i+1}`} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
